import * as React from 'react';
import { ILicensureInstanceForm } from '../../model/forms';
import { default as LicensureInstance } from './instances/LicensureInstance';
import { IInstancedSectionsProperties, InstancedSectionBase} from './InstancedSectionBase';
import Instance from './Instance';

export default class LicensureInstancedSection extends InstancedSectionBase<ILicensureInstanceForm> {  
  constructor(props: IInstancedSectionsProperties<ILicensureInstanceForm>) {
    super(props);

    this.getComponents = this.getComponents.bind(this);
  }

  public getComponents() {
    let components: React.ReactElement[] = [];

    this.props.instances.forEach((value: ILicensureInstanceForm) => {
      components.push(
        <Instance key={`licensure_${value.instanceId}`} id={value.instanceId} onRemove={this.props.onRemoveInstance}>
          <LicensureInstance instance={value} onFieldChange={this.onFieldChange.bind(this, value.instanceId)} isEmpty={this.props.isEmpty} onValidate={this.props.onValidate} validation={this.props.validation} />
        </Instance>
      );
    }, this);

    return components;
  }
}